// extracted by mini-css-extract-plugin
module.exports = {"title":"SettingsInfoInputs_title__xkE_G","label":"SettingsInfoInputs_label__OCKdA","headerIcon":"SettingsInfoInputs_headerIcon__1XCWb"};